import { keyBy, merge, uniq } from 'lodash'
import { POST } from '@/api'

export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
    ended: false,
  },
  mutations: {
    set(state, items) {
      state.byId = keyBy(items, 'id')
      state.allIds = items.map(tag => tag.id)
    },
    add(state, items) {
      state.byId = merge(state.byId, keyBy(items, 'id'))
      state.allIds = uniq(state.allIds.concat(items.map(tag => tag.id)))
    },
    busy(state, busy) {
      state.busy = busy
    },
    ended(state, ended) {
      state.ended = ended
    },
    clear(state) {
      state.byId = {}
      state.allIds = []
      state.ended = false
    },
  },
  getters: {
    all(state) {
      return state.allIds.map(id => state.byId[id])
    },
  },
  actions: {
    async get({ commit, state }, { media, status: receptionStatus, from, to, limit = 20 } = {}) {
      if (state.busy || state.ended) return false
      commit('busy', true)

      const start = state.allIds.length
      const { status, message, data } = await POST('/api/web/import_mail/list', {
        media: media || null,
        status: receptionStatus || null,
        dateFrom: from || null,
        dateTo: to || null,
        start,
        limit,
      })
      if (status === 200) {
        commit(start ? 'add' : 'set', data.mails)
        if (!data.pagenation.next) commit('ended', true)
      } else {
        commit('ended', true)
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
